<div class="iu-dialog">

  <!-- Header -->
  <div class="iu-header">
    <div class="iu-title-wrap">
      <div class="iu-title-icon">
        <mat-icon>add_photo_alternate</mat-icon>
      </div>
      <div>
        <h2 class="iu-title text-capitalize">Upload {{ imageFor }} image</h2>
        <span class="iu-subtitle">Square images look best · 100KB max</span>
      </div>
    </div>
    <button type="button" class="iu-close" mat-dialog-close [disabled]="formSubmitted" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <form id="imageUpload" class="iu-body" (ngSubmit)="submit()">
    <input #file type="file" id="selectedFile" accept="image/*" (change)="preview(file.files)">

    @if (!imgURL) {
      <!-- Empty drop zone -->
      <button type="button" class="iu-dropzone" [class.is-dragging]="dragging"
              (click)="browse()"
              (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
        <div class="iu-dropzone__icon">
          <mat-icon>cloud_upload</mat-icon>
        </div>
        <p class="iu-dropzone__lead">
          <span class="iu-link">Browse</span> or drag an image here
        </p>
        <p class="iu-dropzone__hint">PNG, JPG or GIF — square, under 100KB</p>
      </button>
    } @else {
      <!-- Preview -->
      <div class="iu-preview" [class.is-error]="tooBig">
        <div class="iu-preview__thumb">
          <img [src]="imgURL" alt="Selected image preview">
        </div>
        <div class="iu-preview__meta">
          <span class="iu-preview__name" [title]="fileName">{{ fileName }}</span>
          <span class="iu-preview__size" [class.is-error]="tooBig">
            <mat-icon>{{ tooBig ? 'error_outline' : 'check_circle' }}</mat-icon>
            {{ fileSizeLabel }}@if (tooBig) {<span> · exceeds 100KB</span>}
          </span>
          <div class="iu-preview__actions">
            <button type="button" class="iu-textbtn" (click)="browse()" [disabled]="formSubmitted">
              <mat-icon>sync</mat-icon> Replace
            </button>
            <button type="button" class="iu-textbtn iu-textbtn--danger" (click)="clearSelection()" [disabled]="formSubmitted">
              <mat-icon>delete_outline</mat-icon> Remove
            </button>
          </div>
        </div>
      </div>
    }

    @if (message) {
      <p class="iu-message"><mat-icon>error_outline</mat-icon> {{ message }}</p>
    }
  </form>

  <!-- Footer -->
  <div class="iu-footer">
    <button type="button" class="iu-btn iu-btn--ghost" mat-dialog-close [disabled]="formSubmitted">
      Cancel
    </button>
    <button type="submit" form="imageUpload" class="iu-btn iu-btn--primary"
            [disabled]="formSubmitted || imagePath == null || tooBig">
      @if (formSubmitted) {
        <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
        <span>Uploading…</span>
      } @else {
        <mat-icon>cloud_upload</mat-icon>
        <span>Upload</span>
      }
    </button>
  </div>

</div>
